import { c as _c } from "react/compiler-runtime";
import { useKeyPressEvent } from 'react-use';
import isActiveElementRef from '../helpers/isActiveElementRef';
import { isEnterKey, isSpacebarKey } from '../helpers/keys';

// Note: a ref for the element that we are adding keyboard control to must be
// passed in, so that the callback is only called when the element is focus
const useOnEnterOrSpacebar = (isEnabled, ref, callback) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== callback || $[1] !== isEnabled || $[2] !== ref) {
    t0 = () => {
      if (isEnabled && isActiveElementRef(ref) && callback) {
        callback();
      }
    };
    $[0] = callback;
    $[1] = isEnabled;
    $[2] = ref;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  useKeyPressEvent(isEnterKey, t0);
  let t1;
  if ($[4] !== callback || $[5] !== isEnabled || $[6] !== ref) {
    t1 = () => {
      if (isEnabled && isActiveElementRef(ref) && callback) {
        callback();
      }
    };
    $[4] = callback;
    $[5] = isEnabled;
    $[6] = ref;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  useKeyPressEvent(isSpacebarKey, t1);
};
export default useOnEnterOrSpacebar;